<template lang="pug">
#show-form.contract-show
  .show-card
    q-card-section
      form-header(
        v-if="show_data.common",
        ref="form-header",
        @close-form="closeShow",
        :parentData="{ grid: grid, title: show_data.common.form_header.title + ' № ' + row_id, title_icon: 'show_header.svg' }"
      )

    .spinner-container.form-spinner(v-if="loading")
      q-spinner(color="primary", size="3em")

    div(v-if="!loading")
      q-card-section
        component(
          ref="actions",
          v-if="show_data.common['actions']",
          :is="getShowComponent('actions')",
          @refresh-table="refreshTable",
          @open-form="openForm",
          :parentData="{ row: row, grid: grid, grid_key: grid_key, path: path, data: show_data.common['actions'] }"
        )

      q-card-section
        component(
          ref="blocks",
          v-if="show_data.common['blocks']",
          :is="getShowComponent('blocks')",
          :parentData="{ row: sendingRow(), show_details: false, data: show_data.common['blocks'] }"
        )

      q-card-section
        component(
          ref="tabs",
          v-if="show_data.common['tabs']",
          :is="getShowComponent('tabs')",
          :parentData="{ data: show_data.common['tabs'] }"
        )

      q-card-section
        component(
          ref="form_data",
          v-if="show_data.common['form_data']",
          :is="getShowComponent('form_data')",
          @refresh-table="refreshTable",
          @set-oading="setLoading",
          :parentData="{ item: item, row: row, grid: grid, path: path, data: show_data.common['form_data'] }"
        )
</template>

<script>
import { useShowEdit } from "@/services/useShowEdit";
import formHeader from "../../shared/forms/formHeader";
import showComponents from "../../shared/show_card_components/index";

export default {
  components: {
    formHeader,
    showComponents,
  },

  props: {
    parentData: Object,
  },
  data: function () {
    return {
      path: this.parentData.path,
      row_id: this.parentData.row.id,
      row: {},
      item: "company",
      grid: this.parentData.grid,
      grid_key: this.parentData.grid_key,
      show_data: [],
      loading: true,
    };
  },

  computed: {},

  watch: {
    loading(newVal, oldVal) {
      if ([true, false].includes(newVal)) {
        this.$refs["form-header"]?.setLoading(newVal);
      }
    },
  },

  created() {
    useShowEdit({
      path: () => this.path,
      rowId: () => this.row_id,
      grid: () => this.grid,
      reload: () => {
        this.loading = true;
        return this.loadShowData();
      },
    });

    this.$emit("row-is-active", true);
    setTimeout(() => {
      this.loadShowData();
    }, 500);
  },

  mounted() {},

  beforeMount() {},

  methods: {
    setLoading(val) {
      this.loading = val;
    },

    refreshTable(data) {
      this.refreshRow(data);
      this.$emit("refresh-table", data);
      this.$refs.tabs.refreshGrid("documents");

      if (data.action === "destroy") {
        this.$emit("close-show", this.row);
      }
    },

    refreshRow(data) {
      this.row = data.attr.data || data.attr;
    },

    openForm(data) {
      this.$emit("open-form", data);
    },

    closeShow(row = this.row) {
      this.$emit("close-show", row);
    },

    sendingRow() {
      return this.row;
    },

    loadShowData(params = {}) {
      this.$backend
        .show(this.path, this.row_id, { params: params })
        .then(({ data }) => {
          this.show_data = data;
          this.row = this.show_data.common["data"];
        })
        .catch(error => {
          console.log(error);
          if (error.response) {
            this.reLogin(error.response.status);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../../assets/styles/show/contract/main";

.company-requisites-block {
  background: var(--simple-table-tr-background);
  width: 95%;
  margin-top: 20px;
  border-radius: 10px;

  .spacer {
    width: 90%;
  }
}
</style>
